type HorizontalDividerProps = {
    className?: string;
    bgClassName?: string;
};

const HorizontalDivider = ({
    className,
    bgClassName = "bg-border-grey",    //"bg-humble-grey",
}: HorizontalDividerProps): JSX.Element => (
    <hr className={`${className || ""} ${bgClassName}`} />
);

export default HorizontalDivider;
